<div class="flex w-full gap-4">
	@if (features.vehicleRoadWorthyChecks) {
		<app-vehicle-links-status-button
			[documentsLength]="roadWorthyChecks().length"
			[selectedModule]="motModuleOption"
			[recordId]="recordData()?.id"
			emptyString="vehicles|record|summary-section|active-road-worthy-checks|empty">
			<app-vehicle-road-worthy-checks-link-pill
				[displayValue]="roadWorthyChecks()[0]?.code"
				[id]="roadWorthyChecks()[0]?.sourceId" />
		</app-vehicle-links-status-button>
	}

	@if (features.vehicleInsurances) {
		<app-vehicle-links-status-button
			[documentsLength]="insurances().length"
			[selectedModule]="insuranceModuleOption"
			[recordId]="recordData()?.id"
			emptyString="vehicles|record|summary-section|active-insurances|empty">
			<app-vehicle-insurances-link-pill
				[displayValue]="insurances()[0]?.code"
				[id]="insurances()[0]?.sourceId" />
		</app-vehicle-links-status-button>
	}

	@if (features.vehicleRoadTaxes) {
		<app-vehicle-links-status-button
			[documentsLength]="roadtaxes().length"
			[selectedModule]="roadTaxModuleOption"
			[recordId]="recordData()?.id"
			emptyString="vehicles|record|summary-section|active-road-taxes|empty">
			<app-vehicle-road-taxes-link-pill
				[displayValue]="roadtaxes()[0]?.code"
				[id]="roadtaxes()[0]?.sourceId"
		/></app-vehicle-links-status-button>
	}
</div>
